import React from 'react';

import logo from './gopherBeerLogo48.png';

export const Logo = () => <img src={logo} alt="That's my logo" />;
